import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IonAlert, IonToast } from '@ionic/react';
import { isDefined } from '../../lib/utils';
import { removeToast } from '../../store/actions';
import { withTranslation } from '../../lib/translate';
import { getConfig } from '../../appConfig.js';
import Notification from './notification';

class Toast extends Component {
  constructor(props) {
    super(props);

  }

  showToast = () => {
    const { message, toastType, display, __, removeToast } = this.props;
    if (display === 'toast') {
      return (
        <Notification
          message={__(message)}
          color={toastType}
          onDidDismiss={() => {
            removeToast();
            removeToast();
          }}
        />
      );
    }
    return (
      <IonAlert
        isOpen={true}
        onDidDismiss={() => {
          removeToast(); // removes original toast
          removeToast(); // removes separator toast (empty one)
        }}
        message={__(message)}
        buttons={[
          {
            text: __('Close'),
            role: 'cancel',
            cssClass: 'primary'
          },
        ]}
      >

      </IonAlert>

    );
  };

  render() {
    const { message, __ } = this.props;

    return isDefined(message) && message !== '' ? this.showToast() : null;
  }
}

const stateToProps = (state) => {
  const { common } = state;
  let message = '';
  let toastType = 'warning';
  let display = 'alert';

  if (common && common.toast && common.toast.length > 0) {
    message = common.toast[0].message;
    toastType = common.toast[0].toastType;
    display = common.toast[0].display;
  }

  return {
    message,
    toastType,
    display,
    isConnectedToNetwork: common.isConnectedToNetwork,
  };
};

const dispatchToProps = (dispatch) => {
  return {
    removeToast: () => dispatch(removeToast()),
  };
};

export default connect(stateToProps, dispatchToProps)(withTranslation(Toast));
